
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { RequiresCurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import Page from 'Components/Page/Page';
import ScrollToTop from 'Components/Page/ScrollToTop';

import Home from 'Components/Home/Home';
import Participant from 'Components/Participant/Participant';
import Admin from 'Components/Admin/Admin';

function App () 
{
    return  <RequiresCurrentUserContext>
                <BrowserRouter scrollToTop={true}>
                    <Page>
                        <ScrollToTop>
                            <Routes>
                                <Route path="/*" element={ <Home /> } />
                                <Route path="/participant/*" element={ <Participant /> } />
                                <Route path="/admin/*" element={ <Admin /> } />
                            </Routes>
                        </ScrollToTop>
                    </Page>
                </BrowserRouter>
            </RequiresCurrentUserContext>
}

export default App;
